// extracted by mini-css-extract-plugin
export var articleEditorial = "text-module--articleEditorial--18eaa";
export var articleType = "text-module--articleType--df264";
export var bigContent = "text-module--bigContent--42473";
export var button = "text-module--button--39ce7";
export var condensed = "text-module--condensed--0d887";
export var copy2 = "text-module--copy2--562c8";
export var editorial = "text-module--editorial--fd2bd";
export var h1 = "text-module--h1--d481b";
export var h2 = "text-module--h2--dc774";
export var h3 = "text-module--h3--58bff";
export var h4 = "text-module--h4--f7389";
export var headline_cond = "text-module--headline_cond--b96c7";
export var infotext = "text-module--infotext--8f6db";
export var italic = "text-module--italic--a9b95";
export var light = "text-module--light--88e10";
export var mainNav = "text-module--mainNav--12a38";
export var metanavi = "text-module--metanavi--a021e";
export var p1 = "text-module--p1--bfd3c";
export var p2 = "text-module--p2--619da";
export var p3 = "text-module--p3--9ae7b";
export var quoteText = "text-module--quoteText--546d8";
export var semibold = "text-module--semibold--e7d22";
export var separator = "text-module--separator--1c8d3";
export var tag = "text-module--tag--82374";
export var thin = "text-module--thin--3c16a";
export var upper = "text-module--upper--97199";